(function () {
  'use strict';

  var TRUEMED_SCRIPT_URL =
    'https://static.truemed.com/widgets/product-page-widget.min.js';

  function getWrapper() {
    return document.getElementById('truemed-widget-wrapper');
  }

  function loadTruemedScript() {
    if (document.getElementById('truemed-script')) return;
    var s = document.createElement('script');
    s.id = 'truemed-script';
    s.src = TRUEMED_SCRIPT_URL;
    s.defer = true;
    document.head.appendChild(s);
  }

  function applyVisibility(tags) {
    var wrapper = getWrapper();
    if (!wrapper) return;

    var filter = wrapper.getAttribute('data-tag-filter') || 'none';
    var show = false;

    if (filter === 'none') {
      show = true;
    } else if (filter === 'display-if-eligible') {
      show = tags.indexOf('truemed-eligible') !== -1;
    } else if (filter === 'display-unless-ineligible') {
      show = tags.indexOf('truemed-ineligible') === -1;
    }

    wrapper.style.display = show ? '' : 'none';
    if (show) loadTruemedScript();
  }

  function fetchAndApply(productUrl) {
    var cleanUrl = productUrl.split('?')[0].replace(/\/$/, '');
    fetch(cleanUrl + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) { applyVisibility(data.tags || []); })
      .catch(function () {
        var wrapper = getWrapper();
        if (wrapper) wrapper.style.display = 'none';
      });
  }

  // When the user switches product (honey strength selector, bundle, etc.)
  document.addEventListener('pdp:product-changed', function (e) {
    var detail = (e && e.detail) || {};
    if (detail.url) fetchAndApply(detail.url);
  });

  document.addEventListener('DOMContentLoaded', function () {
    var wrapper = getWrapper();
    if (!wrapper) return;
    // Liquid already set the correct initial visibility.
    // Only need to load the Truemed script if visible.
    if (wrapper.style.display !== 'none') loadTruemedScript();
  });
})();
